// extracted by mini-css-extract-plugin
export default {"signupContainer":"Signup_signupContainer__18gm5"};